import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { tableCellMinWidth } from '@atlaskit/editor-common/styles';
import { getFragmentBackingArray } from '@atlaskit/editor-common/utils';
import { DOMSerializer } from '@atlaskit/editor-prosemirror/model';
import { TableMap } from '@atlaskit/editor-tables/table-map';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
/**
 * This ensures the combined width of the columns (and tbody) of table is always smaller or equal
 * than the table and table wrapper elements. This is necessary as there is no longer
 * padding on the .pm-table-wrapper, so all elements need to be the same width to avoid
 * overflow.
 */
export var getColWidthFix = function getColWidthFix(colwidth, tableColumnCount) {
  return colwidth - 1 / tableColumnCount;
};
export var generateColgroup = function generateColgroup(table) {
  var cols = [];
  if (getBooleanFF('platform.editor.custom-table-width')) {
    var map = TableMap.get(table);
    table.content.firstChild.content.forEach(function (cell) {
      var colspan = cell.attrs.colspan || 1;
      if (Array.isArray(cell.attrs.colwidth)) {
        // We slice here to guard against our colwidth array having more entries
        // Than the we actually span. We'll patch the document at a later point.
        cell.attrs.colwidth.slice(0, colspan).forEach(function (width) {
          cols.push(['col', {
            style: "width: ".concat(getColWidthFix(width ? Math.max(width, tableCellMinWidth) : tableCellMinWidth, map.width), "px;")
          }]);
        });
      } else {
        // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push.apply(cols, _toConsumableArray(Array.from({
          length: colspan
        }, function (_) {
          return ['col', {
            style: "width: ".concat(tableCellMinWidth, "px;")
          }];
        })));
      }
    });
  } else {
    table.content.firstChild.content.forEach(function (cell) {
      var colspan = cell.attrs.colspan || 1;
      if (Array.isArray(cell.attrs.colwidth)) {
        // We slice here to guard against our colwidth array having more entries
        // Than the we actually span. We'll patch the document at a later point.
        cell.attrs.colwidth.slice(0, colspan).forEach(function (width) {
          cols.push(['col', width ? {
            style: "width: ".concat(width, "px;")
          } : {}]);
        });
      } else {
        // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push.apply(cols, _toConsumableArray(Array.from({
          length: colspan
        }, function (_) {
          return ['col', {}];
        })));
      }
    });
  }
  return cols;
};
export var insertColgroupFromNode = function insertColgroupFromNode(tableRef, table) {
  var colgroup = tableRef.querySelector('colgroup');
  if (colgroup) {
    tableRef.removeChild(colgroup);
  }
  colgroup = renderColgroupFromNode(table);
  tableRef.insertBefore(colgroup, tableRef.firstChild);
  return colgroup.children;
};
export var hasTableBeenResized = function hasTableBeenResized(table) {
  return !!getFragmentBackingArray(table.content.firstChild.content).find(function (cell) {
    return cell.attrs.colwidth;
  });
};

/**
 * Check if a table has all the column width set to tableCellMinWidth(48px) or null
 *
 * @param table
 * @returns true if all column width is equal to tableCellMinWidth or null, false otherwise
 */
export var isMinCellWidthTable = function isMinCellWidthTable(table) {
  var cellArray = getFragmentBackingArray(table.content.firstChild.content);
  var isTableMinCellWidth = cellArray.every(function (cell) {
    return cell.attrs.colwidth && cell.attrs.colwidth[0] === tableCellMinWidth || cell.attrs.colwidth === null;
  });
  return isTableMinCellWidth;
};
function renderColgroupFromNode(table) {
  var rendered = DOMSerializer.renderSpec(document, ['colgroup', {}].concat(_toConsumableArray(generateColgroup(table))));
  return rendered.dom;
}
export var getColgroupChildrenLength = function getColgroupChildrenLength(table) {
  var map = TableMap.get(table);
  return map.width;
};